__turbopack_context__.v({
  "grid": "ParagraphIntegrationsGrid-module__WCOq6q__grid",
  "group": "ParagraphIntegrationsGrid-module__WCOq6q__group",
  "header": "ParagraphIntegrationsGrid-module__WCOq6q__header",
  "heading": "ParagraphIntegrationsGrid-module__WCOq6q__heading",
  "lead": "ParagraphIntegrationsGrid-module__WCOq6q__lead",
  "pill": "ParagraphIntegrationsGrid-module__WCOq6q__pill",
  "pills": "ParagraphIntegrationsGrid-module__WCOq6q__pills",
  "section": "ParagraphIntegrationsGrid-module__WCOq6q__section",
  "title": "ParagraphIntegrationsGrid-module__WCOq6q__title",
});
